module.exports = __webpack_public_path__ + "static/ISLIM-1cc744cc2be396a78d16b2f6a904c6a3.png";